import { getDownloadUrlByPath } from '../firebase/storageFunctions';
import { getDefaultContentTypeImage } from '../tools/contentTypeTranslator';

const IS_HTTP_URL_REGEX = new RegExp('^http');
const OLD_PLACEHOLDER_IMAGE_URL = '/img/image_not_found.316e59c7.svg';
const FAILURE_IMAGE = require('../assets/images/placeholder.png');

export async function fetchImagesForDocument(doc) {
  if (!doc) {
    return {};
  }

  let { url, leadImageUrl, webViewableUrl } = doc;
  const originalUrl = url;

  if (url && url !== '') {
    if (!IS_HTTP_URL_REGEX.test(url)) {
      url = await fetchImage(url);
    }
  }

  if (leadImageUrl && leadImageUrl !== '') {
    if (leadImageUrl.includes(OLD_PLACEHOLDER_IMAGE_URL)) {
      leadImageUrl = FAILURE_IMAGE;
    } else if (!IS_HTTP_URL_REGEX.test(leadImageUrl)) {
      leadImageUrl = await fetchImage(leadImageUrl);
      webViewableUrl = await fetchWebViewableContentForDocument(originalUrl);
    }
  } else {
    leadImageUrl = getDefaultContentTypeImage(doc.contentType);
    if (!leadImageUrl || leadImageUrl === '') {
      leadImageUrl = FAILURE_IMAGE;
    }
  }
  return { url: originalUrl, leadImageUrl, webViewableUrl };
}

export function fetchWebViewableContentForDocument(url) {
  return fetchImage(`${url}_webViewable.pdf`, true);
}

export async function fetchImage(url, returnUndefinedOnError) {
  const defaultUrl = returnUndefinedOnError ? undefined : FAILURE_IMAGE;
  try {
    return await getDownloadUrlByPath(url);
  } catch (e) {
    // console.warn(`No image found at '${url}', using default image`);
    return defaultUrl;
  }
}
